import React, { useEffect, useState } from 'react';
import tw from 'twin.macro';
import Producto from 'components/cards/Producto';
import { useParams } from 'react-router-dom';
import { Container, ContentWithPaddingXl } from 'components/misc/Layouts';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import { obtenerProducto } from 'scripts/obtenerProducto';
import { toast } from 'react-toastify';
import Spinner from 'components/Spinner';

const StableContent = tw.div`min-h-[60vh]`;

const PaginaProducto = () => {
	const { id } = useParams();
	const [producto, setProducto] = useState(null);

	useEffect(() => {
		obtenerProducto(id)
			.then((data) => {
				setProducto(data);
			})
			.catch((e) => {
				toast.error(e.message);
			});
	}, [id]);

	return (
		<AnimationRevealPage>
			<Container>
				<ContentWithPaddingXl>
					<StableContent>
						{!producto ? <Spinner text="Cargando producto..." /> : <Producto producto={producto} />}
					</StableContent>
				</ContentWithPaddingXl>
			</Container>
		</AnimationRevealPage>
	);
};

export default PaginaProducto;
